export const SORT_COLUMN_ORGANIZATIONS = {
  Name: 1,
  FullName: 2,
  Type: 3,
  Status: 4,
  //Надо уточнить
  Sub: 5,
};
